import { useEffect, useState } from "react";
import { X, Loader2 } from "lucide-react";

const PromptModal = ({ isOpen, onClose, onGenerate, initialPrompt, generating }) => {
  const [prompt, setPrompt] = useState(initialPrompt || "");

  useEffect(() => {
    if (isOpen) {
      setPrompt(initialPrompt || "");
    }
  }, [isOpen, initialPrompt]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-2xl max-h-[90vh] overflow-hidden flex flex-col">
        <div className="flex items-center justify-between p-4 border-b">
          <h2 className="text-lg font-semibold text-gray-800">Edit Prompt</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <X size={20} />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Customize the prompt for the AI analysis</label>
            <textarea rows={12} className="w-full border rounded-lg p-3 text-sm text-gray-800 font-mono resize-y" value={prompt} onChange={(e) => setPrompt(e.target.value)} placeholder="Enter your prompt here..." />
          </div>
        </div>
        <div className="p-4 border-t flex justify-end gap-3">
          <button onClick={onClose} className="px-4 py-2 text-sm rounded-md border bg-white hover:bg-gray-50 transition" disabled={generating}>
            Cancel
          </button>
          <button onClick={() => onGenerate(prompt)} className="px-4 py-2 text-sm rounded-md bg-sky-400 text-white hover:bg-sky-500 disabled:bg-sky-200 disabled:cursor-wait transition flex items-center gap-2" disabled={generating}>
            {generating ? (
              <>
                <Loader2 size={16} className="animate-spin" />
                Generating...
              </>
            ) : (
              "Generate"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PromptModal;
